import React, { useEffect, useState } from "react";
import WeeklyRevenueChart from "./weeklyStepGraph";
// import NewBarChart from "./newBarChart";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";

const StepGraph = () => {
  const [weeklyRevenue, setWeeklyRevenue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      "/incentive/getLastThreeMonthsWeeklyRevenue"
    )
      .then((res) => {
        if (res.status === 200) {
          setWeeklyRevenue(res?.data?.weeklyRevenue);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="container py-4 ">
      <WeeklyRevenueChart data={weeklyRevenue} />
    </div>
  );
};

export default StepGraph;
